import {
	EnhancedDropDownRHFWithLabel,
	EnhancedTextAreaFieldRHF,
	LabelPosition,
	RHookFormDatePicker,
	RHookFormNumberFieldWithLabel,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";

import { Box } from "@mui/material";
import { FC } from "react";

interface IWireTransferSetupFieldsPanel {
}
export const WireTransferSetupFieldsPanel: FC<
	IWireTransferSetupFieldsPanel
> = ({ }) => {
	return (
		<Box
	// 	sx={{
	// 	"& .calenderWrapper": {

	// 		width: "100%",
	// 	},
	// 	"& .calenderWrapper .p-calendar": {
	// 		width: "100%",
	// 	},
	// 	"& .calenderWrapper input": {
	// 		width: "100%",
	// 		boxSizing: "border-box",
	// 	},
	// }}
		>
			<RHookFormDatePicker
				name="date"
				testId="date"
				label="Date"
				format="M dd, yy"
			// onDateSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
			/>
			<RHookFormNumberFieldWithLabel
				label="Wire Amount"
				id="wireAmount"
				testId={`wire-amount`}
				labelPosition={LabelPosition.Top}
			/>
			<EnhancedDropDownRHFWithLabel
				label="Wire Method"
				selectName="wireMethod"
				testId={`wire-method`}
				labelPosition={LabelPosition.Top}
				items={[
					{ label: "Bank", value: 100 },
					{ label: "Invoice", value: 200 },
				]}
			/>
			<RHookFormTextFieldWithLabel
				label="Confirmation No"
				id="confirmationNo"
				testId={`confirmation-no`}
				labelPosition={LabelPosition.Top}
			/>
			<EnhancedTextAreaFieldRHF
				label="Notes"
				id="notes"
				testId={`notes`}
				labelPosition={LabelPosition.Top}

			/>
		</Box>
	);
};
